import { makeActionFactory } from './actionFactory';
import { DeviceMap } from 'types';

export type ActionType =
    'DEVICES_LOAD_REQUEST'
    | 'DEVICES_LOAD_SUCCESS'
    | 'DEVICES_LOAD_FAILURE'
    | 'DEVICES_CHANGED'
;

const actionFactory = makeActionFactory<ActionType>();


//
//  DEVICES_LOAD_REQUEST action notifies the app that we're trying to load devices
//
export interface DevicesLoadRequestAction {
    type: 'DEVICES_LOAD_REQUEST';
}
export const devicesLoadRequest = actionFactory.empty<DevicesLoadRequestAction>('DEVICES_LOAD_REQUEST');


//
//  DEVICES_LOAD_SUCCESS action notifies the app that we successfully loaded devices
//
export interface DevicesLoadSuccessAction {
    type: 'DEVICES_LOAD_SUCCESS';
    payload: {
        cameras?: DeviceMap;
        accessDevices?: DeviceMap;
        integrations?: DeviceMap;
    };
}
export const devicesLoadSuccess = actionFactory.payload<DevicesLoadSuccessAction, DevicesLoadSuccessAction['payload']>('DEVICES_LOAD_SUCCESS');


//
//  DEVICES_LOAD_FAILURE action notifies the app that we failed to load devices
//
export interface DevicesLoadFailureAction {
    type: 'DEVICES_LOAD_FAILURE';
    payload: Error;
    error: true;
}
export const devicesLoadFailure = actionFactory.error<DevicesLoadFailureAction>('DEVICES_LOAD_FAILURE');


//
//  DEVICES_CHANGED action notifies the app that devices have changed
//  (asynchronously via server push rather than us loading them)
//
export type DeviceDelta = {}; // TODO: ...
export interface DevicesChangedAction {
    type: 'DEVICES_CHANGED';
    payload: DeviceDelta[];
}
export const devicesChanged = actionFactory.payload<DevicesChangedAction, DeviceDelta[]>('DEVICES_CHANGED');



// WEBPACK FOOTER //
// ./src/actions/deviceActions.ts